import { render, staticRenderFns } from "./StoreTagBase.vue?vue&type=template&id=49e8f954&"
import script from "./StoreTagBase.vue?vue&type=script&lang=js&"
export * from "./StoreTagBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports